import { render } from "./MenuDropDownIndicator.vue?vue&type=template&id=a842ea40"
import script from "./MenuDropDownIndicator.vue?vue&type=script&lang=js"
export * from "./MenuDropDownIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__